<template>
  <el-breadcrumb separator="/">
    <el-breadcrumb-item v-for="(item, index) in breadcrumbList" :key="index" :to="item.to">
      <router-link :to="{ path: item.path }" v-if="item.path">{{ item.name }}</router-link>
      <span v-else>{{ item.name }}</span>
      <!-- {{ item.name }} -->
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
export default {
    computed: {
    breadcrumbList() {
      let matched = this.$route.matched.filter(item => item.meta && item.meta.breadcrumb);
      let breadcrumbList = [];

      // 首页不显示，但其他页面的第一个面包屑是首页
      if (matched.length > 0 && matched[0].path !== '/') {
        breadcrumbList.push({ name: '首页', path: '/' });
      }

      // return breadcrumbList.concat(matched);
      breadcrumbList = breadcrumbList.concat(
        matched.map(route => ({
          name: route.meta.breadcrumb,
          path: route.path
        }))
      );

      return breadcrumbList;
      // const breadcrumbList = matched.map((item, index) => ({
      //   name: item.meta.breadcrumb,
      //   to: index === 0 ? { path: '/' } : { name: item.name }
      // }));
      // return breadcrumbList;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Breadcrumb.vue